<template>
  <b-container fluid>
    <b-row class="mb-2 pt-1 pb-1" style="background-color: rgba(0, 0, 0, 0.03);">
      <b-col>
        <span class="font-weight-bold">{{shipping.country.germany.title}}</span>
      </b-col>
    </b-row>
    <b-row v-for="type in shipping.country.germany.types" :key="type.id" style="border-bottom: 1px solid rgba(0, 0, 0, 0.03);" class="pb-1">
      <b-col>
        {{type.desc}}
      </b-col>
      <b-col>
        <span class="float-right">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(type.price)}}</span>
      </b-col>
    </b-row>
    <b-row class="mb-2 mt-3 pt-1 pb-1" style="background-color: rgba(0, 0, 0, 0.03);">
      <b-col>
        <span class="font-weight-bold">{{shipping.country.eu.title}}</span>
      </b-col>
    </b-row>
    <b-row v-for="type in shipping.country.eu.types" :key="type.id" style="border-bottom: 1px solid rgba(0, 0, 0, 0.03);" class="pb-1">
      <b-col>
        {{type.desc}}
      </b-col>
      <b-col>
        <span class="float-right">{{new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(type.price)}}</span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DataShipping from './../../../data/main/config/shippingCosts'

export default {
  data () {
    return {
      shipping: DataShipping.shippingCosts
    }
  }
}
</script>

<style>
</style>
